import useMediaQuery from "../hooks/useMediaQuery"
import { motion } from "framer-motion"
import extIcon from "../assets/extensionIcon.svg"
import { useState } from "react"
import SignUpDialog from "../shared/SignUpDialog"

const Instructions = () => {
    const isAboveMd = useMediaQuery("(min-width: 768px)")
    const isMobile = useMediaQuery("(max-width: 768px)");
    const isLandscapeMobile = useMediaQuery("(max-height: 440px) and (orientation: landscape)")
    const [signingUp, setSigningUp] = useState(false)

    // Container style for the instruction steps.
    // On mobile (isAboveMd false) we stack the divs (flexDirection: "column")
    const instructionsContainerStyle = {
        display: "flex",
        flexDirection: isAboveMd ? "row" : "column",
        justifyContent: isAboveMd ? "space-between" : "center",
        gap: isAboveMd ? "1rem" : "1rem", // adjust gap as needed
        width: "100%",
    }

    // Step box style: on mobile use full width instead of 25%
    const stepBoxStyle = {
        padding: "10px",
        borderRadius: "0.5rem",
        height: "100%",
        width: isAboveMd ? "25%" : "100%",
        background: "linear-gradient(to right, rgb(127 245 57), rgb(45, 212, 191))",
        boxShadow: "inset 0 0 12px 12px white, inset 0 0 3px 2px white",
    }

    return (
        <section id="instructions"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "100vh",
                paddingTop: '4rem',
                paddingBottom: '4rem'
            }}
        >
            <motion.div
                style={{
                    marginBottom: isAboveMd ? "3rem": "0"
                }}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                transition={{ delay: 0.4, duration: 0.6 }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1 },
                }}
            >
                <h1
                    className="mx-auto font-montserrat text-center text-gray-800 font-semibold p-4"
                    style={{
                        fontSize: "1.875rem",
                        lineHeight: "2.25rem"
                    }}
                >
                    Get Started with TIMECRUNCH
                </h1>
                {isAboveMd && !isLandscapeMobile ? (
                    ""
                ) : (
                    <div className="w-1/3 sm:w-60 mx-auto h-[1px] bg-gradient-brand mb-8 ss:mb-4 sm:mb-8 landscape-mobile:hidden"></div>
                )}
            </motion.div>

            <div
                className="xl:w-5/6 h-full flex flex-col items-center justify-center pb-16 font-quest text-gray-100"
                style={{
                    gap: isAboveMd ? "4rem" : "1rem"
                }}
            >
                <div style={instructionsContainerStyle}>
                    {/* Step 1 */}
                    <div style={stepBoxStyle}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            className="text-center h-full rounded-lg flex flex-col bg-neutral-300 pb-8 landscape-mobile:pb-2"
                            variants={{
                                hidden: { opacity: 0 },
                                visible: { opacity: 1 },
                            }}
                        >
                            <p className="text-2xl lg:text-3xl py-4 landscape-mobile:py-2 text-gray-800 ">
                                1
                            </p>
                            <div
                                onClick={() => setSigningUp(true)}
                                className="m-auto text-gray-800 border-[1px] border-neutral-800 hover:bg-neutral-800 bg-neutral-300 hover:text-gray-100 rounded-md py-4 w-[90%] hover:cursor-pointer"
                            >
                                Sign Up Here!
                            </div>
                        </motion.div>
                    </div>
                    {/* Step 2 */}
                    <div style={stepBoxStyle}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            className="text-center h-full rounded-lg flex flex-col bg-neutral-300 pb-8 landscape-mobile:pb-2"
                            variants={{
                                hidden: { opacity: 0 },
                                visible: { opacity: 1 },
                            }}
                        >
                            <p className="text-2xl lg:text-3xl py-4 landscape-mobile:py-2 text-gray-800">
                                2
                            </p>
                            <a
                                href={process.env.REACT_APP_CHROME_EXTENSION_LISTING_LINK}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="m-auto w-[90%] py-4 rounded-md hover:cursor-pointer text-gray-800 border-[1px] border-neutral-800 hover:bg-neutral-900 bg-neutral-300 hover:text-gray-100"
                            >
                                download the TIMECRUNCH extension here
                            </a>
                        </motion.div>
                    </div>
                    {/* Step 3 */}
                    <div style={stepBoxStyle}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            className="text-center h-full rounded-lg flex flex-col bg-neutral-300"
                            variants={{
                                hidden: { opacity: 0 },
                                visible: { opacity: 1 },
                            }}
                        >
                            <p className="text-2xl lg:text-3xl py-4 landscape-mobile:py-2 text-gray-800 ">
                                3
                            </p>
                            <div className="m-auto mb-8 px-4">
                                <p className="text-gray-800">
                                    click the extension button
                                    <span>
                    <img src={extIcon} alt="" className="h-16 mx-auto bg-gray-800" />
                  </span>
                                    <span className="landscape-mobile:hidden">
                    on your browser to login
                  </span>
                                </p>
                                <p className="landscape-mobile:hidden hidden md:inline text-gray-800">
                                    (top right if using chrome)
                                </p>
                            </div>
                        </motion.div>
                    </div>
                    {/* Step 4 */}
                    <div style={stepBoxStyle}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            className="text-center h-full rounded-lg flex flex-col bg-neutral-300 pb-8 landscape-mobile:pb-2"
                            variants={{
                                hidden: { opacity: 0 },
                                visible: { opacity: 1 },
                            }}
                        >
                            <p className="text-2xl lg:text-3xl py-4 landscape-mobile:py-2 text-gray-800 ">
                                4
                            </p>
                            <div className="p-2 m-auto">
                                <p className="text-gray-800">Sign in to</p>
                                <a
                                    href="https://www.tennistv.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:underline"
                                >
                                    ATP TENNIS TV{" "}
                                </a>
                                <p className="text-gray-800">or</p>
                                <a
                                    href="https://www.tennischannel.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:underline"
                                >
                                    TENNIS CHANNEL PLUS
                                </a>
                                <p className="text-gray-800 landscape-mobile:hidden">
                                    and start watching!
                                </p>
                            </div>
                        </motion.div>
                    </div>
                </div>
                <p className="text-sm text-gray-800">
                    TIMECRUNCH is currently available on desktop only
                </p>
            </div>
            <SignUpDialog isOpen={signingUp} setIsOpen={setSigningUp} />
        </section>
    )
}

export default Instructions
